import React from "react";
import { useTranslation } from "react-i18next";
import BlueArrow from "../../../../assets/profile/icons/arrowBlue.svg";
import { useMediaQuery } from "@mui/material";
import { setAffiliatesFilterSidebarOpen } from "../../../../store/features/profileSlice";
import { useAppDispatch } from "../../../../store/store";

export const AffiliatesTitleAndFilterContainer = () => {
  const { t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();
  const is970px = useMediaQuery("(max-width: 970px)");

  return (
    <div className="title-and-filter-container">
      <div className="title-and-filter-container-title">{t("affiliates")}</div>
      {is970px && (
        <div
          className="title-and-filter-container-filter-btn"
          onClick={() => dispatch(setAffiliatesFilterSidebarOpen())}
        >
          <div>{t("filters")}</div>
          <img src={BlueArrow} />
        </div>
      )}
    </div>
  );
};
